export const priorityRange = [
  {
    name: 'Highest',
    value: 4,
  },
  {
    name: 'High',
    value: 3,
  },
  {
    name: 'Medium',
    value: 2,
  },
  {
    name: 'Low',
    value: 1,
  },
  {
    name: 'Lowest',
    value: 0,
  },
];
